// Loader.js
import React from "react";
import "./Loader.css"; // Import the external CSS

const Loader = () => {
  return (
    <div className="loader-container">
      <h6>Loading...</h6>
      <div className="loader-ring"></div>
    </div>
  );
};

export default Loader;
